import React from 'react';
import { Link } from 'react-router-dom';

const DocsSidebar = ({ articles, currentSlug, headings, activeHeadingId }) => {
  return (
    <aside className="docs-sidebar">
      <div className="docs-sidebar-nav">
        <span className="docs-sidebar-label">Articole</span>
        <ul>
          {articles.map((a) => (
            <li key={a.slug} className={a.slug === currentSlug ? 'active' : ''}>
              <Link to={`/docs/${a.slug}`}>{a.title}</Link>
            </li>
          ))}
        </ul>
      </div>

      {headings.length > 0 && (
        <div className="docs-sidebar-toc">
          <span className="docs-sidebar-label">Cuprins</span>
          <ul>
            {headings.map((h) => (
              <li
                key={h.id}
                className={`toc-h${h.level}${activeHeadingId === h.id ? ' toc-active' : ''}`}
              >
                <a href={`#${h.id}`}>{h.text}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </aside>
  );
};

export default DocsSidebar;
